var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signup-select-field"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('v-select',_vm._g(_vm._b({attrs:{"outlined":""},scopedSlots:_vm._u([{key:"prepend-inner",fn:function(){return [_c('div',[_c('SIcon',{attrs:{"name":_vm.iconName}})],1)]},proxy:true}])},'v-select',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }